import Vue from 'vue'
import vuex from 'vuex'
import persistedState from 'vuex-persistedstate'

Vue.use(vuex)

export default new vuex.Store({
  state: {
    deviceType: null,
  },
  mutations: {
    setDeviceType: (state, data) => {
      state.deviceType = data
    },
  },
  plugins: [persistedState()]
})



// WEBPACK FOOTER //
// ./src/store/index.js